import React, { useEffect, useState } from "react";
import { FaHome, FaRegTrashAlt } from "react-icons/fa";
import { MdOutlineModeEdit } from "react-icons/md";
import { Link } from "react-router-dom";
import { axiosInstance } from "../utils/axiosInstance";
import { HiBuildingOffice } from "react-icons/hi2";
import { BsMotherboardFill } from "react-icons/bs";
import Loader from "../Loader";

const Address = () => {
  const [loader, setloader] = useState(false);

  const [allAddress, setAllAddress] = useState([]);
  const getAllAddress = async () => {
    setloader(true);
    try {
      await axiosInstance.get("user/addressmanagement").then((response) => {
        if (response?.data?.status === true) {
          setAllAddress(response?.data?.address_managements);
          setloader(false);
        }
      });
    } catch (error) {
      setloader(false);
    }
  };

  useEffect(() => {
    getAllAddress();
  }, []);

  const handleDeleteAddress = async (id) => {
    setloader(true);

    try {
      await axiosInstance
        .delete(`user/addressmanagement/${id}`)
        .then((response) => {
          if (response?.data?.status === true) {
            setloader(false);

            // setAllAddress(response?.data?.address_managements);
            getAllAddress();
          }
        });
    } catch (error) {
      setloader(false);
    }
  };

  return (
    <div className="dashboard_content">
      <div className="dashboard_body address_body">
        <h3>
          address
          <Link className="dash_add_new_address" to="/addaddress">
            add new
          </Link>
        </h3>
        {loader ? (
          <Loader />
        ) : (
          <div className="dashboard_address">
            <div className="dashboard_existing_address">
              <div className="row">
                {allAddress?.length > 0 ? (
                  allAddress?.map((e, i) => (
                    <div className="col-md-6">
                      <div className="checkout_single_address">
                        <div className="form-check">
                          <label className="form-check-label">
                            <span className="icon">
                              {e?.type === "office" ? (
                                <HiBuildingOffice />
                              ) : e?.type === "home" ? (
                                <FaHome />
                              ) : (
                                <BsMotherboardFill />
                              )}{" "}
                              {e?.type}
                            </span>
                            <span className="address">{e?.street_address}</span>
                            <span className="address border-0 p-0">
                              {e?.city}
                            </span>
                          </label>
                        </div>
                        <ul>
                          <li>
                            <Link to="/editaddress " state={e}>
                              <MdOutlineModeEdit />
                            </Link>
                          </li>
                          <li>
                            <button onClick={() => handleDeleteAddress(e?.id)}>
                              <FaRegTrashAlt />
                            </button>
                          </li>
                        </ul>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="container text-center fs-3">
                    No Address Found
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Address;
